var _excluded = ["data"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import axios from 'axios';
export var buildRequestConfig = function buildRequestConfig(opts, extras) {
  var _extras$headers;

  return _objectSpread(_objectSpread({
    params: opts === null || opts === void 0 ? void 0 : opts.query,
    cancelToken: opts === null || opts === void 0 ? void 0 : opts.cancelToken
  }, extras !== null && extras !== void 0 ? extras : {}), {}, {
    headers: _objectSpread({}, (_extras$headers = extras === null || extras === void 0 ? void 0 : extras.headers) !== null && _extras$headers !== void 0 ? _extras$headers : {})
  });
};
export var buildResponse = function buildResponse(defaultValue) {
  var _defaultValue$meta;

  return {
    ok: false,
    data: defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.data,
    meta: (_defaultValue$meta = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.meta) !== null && _defaultValue$meta !== void 0 ? _defaultValue$meta : {},
    cancelled: false,
    error: undefined
  };
};
export var executeRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(method, url, data, opts, defaults, extras) {
    var _extras;

    var svcRes, axiosMethod, axiosParams, _resMeta$meta, res, _res$data, resData, resMeta;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            svcRes = buildResponse(defaults);
            axiosMethod = axios.get;
            axiosParams = [url];
            extras = (_extras = extras) !== null && _extras !== void 0 ? _extras : {};

            if (opts !== null && opts !== void 0 && opts.query && !extras.params) {
              extras.params = opts.query;
            }

            _context.t0 = method;
            _context.next = _context.t0 === 'post' ? 8 : _context.t0 === 'patch' ? 11 : _context.t0 === 'delete' ? 14 : 16;
            break;

          case 8:
            axiosMethod = axios.post;
            axiosParams.push(data !== null && data !== void 0 ? data : {});
            return _context.abrupt("break", 16);

          case 11:
            axiosMethod = axios.patch;
            axiosParams.push(data !== null && data !== void 0 ? data : {});
            return _context.abrupt("break", 16);

          case 14:
            axiosMethod = axios["delete"];
            return _context.abrupt("break", 16);

          case 16:
            axiosParams.push(buildRequestConfig(opts, extras));
            _context.prev = 17;
            _context.next = 20;
            return axiosMethod.apply(void 0, axiosParams);

          case 20:
            res = _context.sent;
            _res$data = res.data, resData = _res$data.data, resMeta = _objectWithoutProperties(_res$data, _excluded);
            svcRes.ok = true;
            svcRes.data = resData;
            svcRes.meta = (_resMeta$meta = resMeta.meta) !== null && _resMeta$meta !== void 0 ? _resMeta$meta : resMeta;
            _context.next = 31;
            break;

          case 27:
            _context.prev = 27;
            _context.t1 = _context["catch"](17);
            svcRes.cancelled = axios.isCancel(_context.t1);

            if (!svcRes.cancelled) {
              svcRes.error = _context.t1;
            }

          case 31:
            return _context.abrupt("return", svcRes);

          case 32:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[17, 27]]);
  }));

  return function executeRequest(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();